import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

export interface TabOption {
  label: string;
  value: string;
  icon: string;
  badge?: number;
}

/**
 * Composant de navigation à onglets pour le drawer Notes & Todos
 * Style inspiré de Notion/Linear avec badges de notification
 */
@Component({
  selector: "app-eva-tabs-navigation",
  templateUrl: "./eva-tabs-navigation.component.html",
  styleUrls: ["./eva-tabs-navigation.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EvaTabsNavigationComponent {
  @Input() tabs: TabOption[] = [];
  @Input() activeTab: string = "";
  @Output() tabChange = new EventEmitter<string>();

  selectTab(tabValue: string): void {
    if (tabValue !== this.activeTab) {
      this.activeTab = tabValue;
      this.tabChange.emit(tabValue);
    }
  }
}
